import React, { useState, useRef } from "react";
import { Dimmer, Loader, Button, Icon, Form } from "semantic-ui-react";
import Cookies from "js-cookie";
import { useHistory } from "react-router-dom";
import "semantic-ui-offline/semantic.min.css";
import LineLoginButton from "react-lib/apps/IsHealth/Common/Line/LoginButton";
import FacebookLoginButton from "react-lib/apps/IsHealth/Common/FacebookLogin/FBLoginButton";
import settings from "../config/config";
import LoginForm from "react-lib/apps/IsHealth/Common/PasswordLogin/LoginForm";
import { useIntl } from "react-intl";

interface PlatformLoginProps {
  controller?: Record<string, any>;
  lineLoginManager?: Record<string, any>;
  onLoginSuccess?: () => void;
  onLoginFacebookSiteSuccess?: () => void;
  onHaveApiToken?: () => void;
  openSetupEmail?: () => void;
  redirectUri?: string;
  device_id?: string;
  facebookLogin?: (name: string) => void;
}

const DEFAULT_PROPS = {
  controller: null,
  lineLoginManager: null,
  onLoginSuccess: () => {},
  onLoginFacebookSiteSuccess: () => {},
  onHaveApiToken: () => {},
  openSetupEmail: () => {},
  redirectUri: null,
};

const PlatformLogin = (propsParam: PlatformLoginProps) => {
  const props = {
    ...DEFAULT_PROPS,
    ...Object.fromEntries(Object.entries(propsParam).filter(([_, value]) => value !== undefined)),
  };
  const intl = useIntl();
  const history = useHistory();
  const lineButtonRef = useRef();
  const [isLoading, setIsLoading] = useState(false);

  const gotoLineLogin = () => {
    if (props.lineLoginManager) {
      props.lineLoginManager.openLogin();
    }
  };

  const handleResponseFacebook = async ({ data, deviceId, fbResponse }: any) => {
    const postData = {
      accessToken: fbResponse.authResponse?.accessToken,
      app: settings.APP_NAME,
      device_id: deviceId,
    };

    const [response, error] = await props.controller?.getRegisterByTokenFacebook(postData);

    if (response) {
      props.facebookLogin?.(data.name);
      props.onLoginSuccess?.(response);
    }
  };

  React.useEffect(() => {
    if (Cookies.get("apiToken")) {
      props.onHaveApiToken();
    }
  }, []);

  return (
    <Dimmer.Dimmable dimmed={isLoading}>
      <div className="Login">
        <div className="fbLogin">
          {settings.PENTA_ACC_LINE_LOGIN ? (
            <LineLoginButton
              onClick={gotoLineLogin}
              ref={lineButtonRef}
              textStyle={{ margin: "25px 70px" }}
              logoStyle={{ width: "40px", height: "40px" }}
              style={{
                height: "40px",
                margin: "auto",
                marginBottom: "30px",
                maxWidth: "284px",
                display: "flex",
                alignItems: "center"
              }}
            />
          ) : null}
          {settings.PENTA_ACC_FACEBOOK_LOGIN ? (
            <FacebookLoginButton
              style={{
                display: "block",
                height: "40px",
                margin: "auto",
                marginBottom: "30px",
                maxWidth: "284px",
              }}
              appId="3314489911914234"
              deviceId={props.device_id}
              logoStyle={{ height: "40px", padding: "5px", width: "40px" }}
              textStyle={{ margin: "25px 45px" }}
              version="v9.0"
              onCallback={handleResponseFacebook}
              onLoading={setIsLoading}
              onSiteSuccess={props.onLoginFacebookSiteSuccess}
            />
          ) : null}
          {settings.EMAIL_LOGIN || settings.PENTA_ACC_EMAIL_LOGIN ? (
            <div
              onClick={() => {
                history.push("/EmailLogin");
              }}
              style={{
                backgroundColor: "white",
                color: "#5dbcd2",
                border: "2px solid #5DBCD2",
                margin: "0 auto",
                width: "278px",
                height: "40px",
                maxWidth: "284px",
                lineHeight: "38px",
                cursor: "pointer",
              }}
            >
              <Icon style={{ padding: "5px", float: "left" }} name="mail" size="big" />
              <span style={{ margin: "0 10px" }}>
                {intl.formatMessage({ id: "ลงชื่อเข้าใช้งานด้วยอีเมล" })}
              </span>
            </div>
          ) : null}
        </div>
        {settings.USERNAME_PASSWORD_LOGIN ? (
          <div className="pwdLogin">
            <LoginForm usernameText="Email or phone no." onLoginSuccess={props.onLoginSuccess} />
          </div>
        ) : null}
      </div>
      <Dimmer active={isLoading} inverted>
        <Loader size="massive">{"Loading"}</Loader>
      </Dimmer>
    </Dimmer.Dimmable>
  );
};

export default PlatformLogin;
